import React from 'react';

const Header4 = (props) => (
  <h4 className={`text header-4 stronger ${props.className ? props.className : ''}`}>
    {props.text}
  </h4>
);

export default Header4;


// WEBPACK FOOTER //
// ./src/components/typographies/header4.js